import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { IconStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='claims-find-your-policy'
      backgroundVariant='darkDefault'
      themeType='darkTheme'>
      <Row align='center'>
        <Col
          medium={8}
          align='center'>
          <IconStyled />
          <Typography
            component='h2'
            themeType='darkTheme'
            nextElement='typography'>
            Can&#39;t find <WidowBlock>your policy&#63;</WidowBlock>
          </Typography>
          <Typography
            themeType='darkTheme'
            disableBottomPadding>
            If you&#39;ve misplaced or lost your life, disability, or long&#45;term care policy documents, call us at&nbsp;
            <Link
              themeType='darkTheme'
              variant='primaryDeemphasize'
              linkUrl='tel:8003888123'>
              <WidowBlock>(800) 388&#45;8123</WidowBlock>
            </Link> and we&#39;ll get them to you.
          </Typography>
        </Col>
      </Row>
    </SectionContainer>
  );
};
